import { userConstants } from '../constants/user.constants.js';

export default function validationCNCApplication(state = {}, action) {
    switch (action.type) {
        case userConstants.POST_VALIDATE_CNC_REQUEST:
            return state
        case userConstants.POST_VALIDATE_CNC_SUCCESS:
            return {
                ...state,
                data: action.payload
            }
            
        case userConstants.POST_VALIDATE_CNC_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        default:
            return state
    }
}